<template>
    <v-dialog
        v-if="isLeserserviceOrHigher"
        v-model="showDialog"
        max-width="500"
        persistent
        class="reset-password flex-none"
    >
        <template #activator="{ on }">
            <div v-on="on" class="reset-password-activator">
                <v-tooltip bottom v-if="alternativeBtn">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" v-bind="$attrs" class="drei_60-btn mb-2" block>Passwort zurücksetzen</v-btn>
                    </template>
                    <div class="max-width-btn">
                        Versenden einer automatisierten Email an den Kunden, über die er sein Passwort selbständig ändern kann.
                    </div>
                </v-tooltip>
                <v-tooltip left v-if="!alternativeBtn">
                    <template #activator="{ on }">
                        <v-btn v-on="on" v-bind="$attrs" text icon class="drei_60-black-text">
                            <v-icon v-bind="$attrs">mdi-key-variant</v-icon>
                        </v-btn>
                    </template>
                    <span>Passwort zurücksetzen</span>
                </v-tooltip>
            </div>
        </template>
        <v-card>
            <v-card-title class="headline" primary-title>
                Passwort zurücksetzen
            </v-card-title>
            <v-card-text>
                <div class="center-progress-circular" v-if="isCheckingCustomer">
                    <v-progress-circular indeterminate :size="50" color="primary">
                    </v-progress-circular>
                </div>
                <div v-if="!isCheckingCustomer">
                    <LabelValue label="Name" :value="fullname" />
                    <LabelValue label="Email" :value="email" />
                    <v-form v-model="storeValid" v-if="!existInEvalanche" ref="evalancheStoreForm">
                        <EvalancheStoreSelect @change="setStore" :loading="loading" :store="store" />
                    </v-form>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" outlined @click="abbort" :disabled="loading || isCheckingCustomer">Abbrechen</v-btn>
                <v-btn color="success" outlined :loading="loading && processing" :disabled="loading || isCheckingCustomer || !storeValid" @click="reset">Passwort zurücksetzen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';
import EvalancheStoreSelect from '@/components/EvalancheStoreSelect.vue';
import LabelValue from '@/components/LabelValue.vue';

export default {
    name: 'ResetPassword',
    props: ['ssoId', 'alternativeBtn'],
    components: {
        EvalancheStoreSelect,
        LabelValue,
    },
    data() {
        return {
            showDialog: false,
            processing: false,
            storeValid: false,
        };
    },
    computed: {
        ...mapState('customerResetPassword', [
            'loading',
            'email',
            'store',
            'isCheckingCustomer',
            'existInEvalanche',
        ]),
        ...mapGetters('customerResetPassword', ['fullname']),
        ...mapGetters(['isLeserserviceOrHigher']),
    },
    methods: {
        abbort() {
            this.$emit('close');
            this.showDialog = false;
            this.snackInfo('Das Zurücksetzen des Passworts wurde abgebrochen.');
        },
        reset() {
            this.processing = true;
            this.resetPassword()
                .then(() => {
                    this.$emit('close');
                    this.snackSuccess('Es wurde eine E-Mail zum zurücksetzen '
                        + 'des Passworts an den Kunden verschickt.');
                    this.showDialog = false;
                })
                .catch(() => {
                    this.snackError('Das Passwort konnte nicht zurückgesetzt werden.');
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        ...mapActions('customerResetPassword', ['checkCustomer', 'resetPassword']),
        ...mapMutations('customerResetPassword', ['resetState', 'setStore']),
        ...mapMutations('snackbar', {
            snackError: 'error',
            snackSuccess: 'success',
            snackInfo: 'info',
        }),
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.checkCustomer(this.ssoId)
                    .then(() => {
                        if (!this.existInEvalanche) {
                            this.storeValid = false;
                            this.$refs.evalancheStoreForm.validate();
                        } else {
                            this.storeValid = true;
                        }
                    })
                    .catch(() => {
                        this.snackError('Es ist ein Fehler beim Überprüfen des Nutzers aufgetreten.');
                        this.showDialog = false;
                        this.$emit('close');
                    });
            } else {
                this.resetState();
                this.processing = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .center-progress-circular {
        display: flex;
        height: 100px;
        justify-content: center;
        align-items: center;
        > * {
            flex: none;
        }
    }
    .reset-password-activator {
        width: 100%;
        display: block;
    }
</style>
